<template>
  <div id="scaffolding">
    <TheHeader :class="{'mobile-hide': show !== 'header'}" />
    <TheInstructionsMenu :class="{'mobile-hide': show !== 'tactics'}" />
    <TheTacticsBoard :class="{'mobile-hide': show !== 'tactics'}" />
    <TheStatsBox :class="{'mobile-hide': show !== 'stats'}" />
    <TheProblemsList :class="{'mobile-hide': show !== 'suggestions'}" />
    <TheMobileMenu :show="show" @update:showPanel="show = $event" />
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import TheInstructionsMenu from "@/components/TheInstructionsMenu.vue";
import TheTacticsBoard from "@/components/TheTacticsBoard.vue";
import TheStatsBox from "@/components/TheStatsBox.vue";
import TheProblemsList from "@/components/TheProblemsList.vue";
import TheMobileMenu from "@/components/TheMobileMenu.vue";

export default {
  components: {
    TheHeader,
    TheStatsBox,
    TheTacticsBoard,
    TheInstructionsMenu,
    TheProblemsList,
    TheMobileMenu,
  },

  data() {
    return {
      show: "header",
    }
  }
};
</script>

<style>
.--uppercase {
  text-transform: uppercase;
}

.--capitalise {
  text-transform: capitalize;
}

.--capitalise-first-letter:first-letter {
  text-transform: capitalize;
}

#scaffolding {
  background: #167e45;
  display: grid;
  grid-template-columns: 1fr 5fr 4fr;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    "instructions tactics header"
    "instructions stats problems"
    "footer footer footer";
  border-bottom: solid 60px #0c503c;
  max-width: 1933px;
  overflow-x: clip;
}

@media only screen and (max-width: 1339px) {
  #scaffolding {
    grid-template-areas:
      "header header header"
      "instructions tactics tactics"
      "stats stats problems"
      "footer footer footer";
    grid-template-columns: 2fr 3fr 5fr;
  }
}

@media only screen and (max-width: 767px) {
  #scaffolding {
    grid-template-areas:
      "header"
      "instructions"
      "tactics"
      "stats"
      "problems"
      "footer";
    grid-template-columns: 1fr;
  }
}
</style>
